import React from 'react'
import { useSelector } from 'react-redux'

import { getSession } from '../../../store/auth'

const withAuthorized = (WrappedComponent) => (props) => {
  const session = useSelector(getSession)

  if (!session.isAuthed) {
    return null
  }

  return <WrappedComponent {...props} session={session} />
}

export default withAuthorized
